<template>
  <el-button
    :loading="loading"
    :type="status === 'active' ? 'danger' : 'success'"
  >
    <template #icon>
      <IcStop v-if="status === 'active'" /> <IcStart v-else /> </template
    >{{ buttonText }}</el-button
  >
</template>

<script setup>
import { defineProps, computed } from "vue";
import IcStart from "@/shared/ui/icons/IcStart.vue";
import IcStop from "@/shared/ui/icons/IcStop.vue";

const props = defineProps({
  status: {
    type: String,
    default: "",
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const buttonText = computed(() => {
  return props.status === "active" ? "Stop Test" : "Run Test";
});
</script>
